// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:37
import { PersistentObject } from '../../SagaBase/PersistentObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class ServiceResourceSector_abstract extends PersistentObject {
  static $t: string = 'SagaSchema.ServiceResourceSector';
  $t: string = 'SagaSchema.ServiceResourceSector';

  public static GetMembers(): string[] {
    return ['SvcResourceUId', 'GeoSectorId', 'SectorName', 'TreeTypeId'].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return ServiceResourceSector_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public SvcResourceUId: Guid = GuidTools.Empty;
  public GeoSectorId: number = 0;
  public SectorName: string;
  public TreeTypeId: number = 0;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ObjId(): any {
    return this.SvcResourceUId;
  }
  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
